import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossLeads } from '../components/views/militaryHearingLossView/MilitaryHearingLossLeads/MilitaryHearingLossLeads'

function MilitaryHearingLossLeadsSearch() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Clients" />
                    <MilitaryHearingLossLeads />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossLeadsSearch
